import React, {FC} from "react"
import PropTypes from "prop-types"

import {FormattedMessage} from "@irati/utils/lang"
import appsConfig from "@irati-web/app/src/routeConfig"
import {Nav, Ul, MenuListItem, MenuItemLink} from "./styled"

export type MenuItem = {
  id?: string
  to: string
  label: string
  isCategory?: boolean | undefined
  onClick?: () => void
  color?: string
  app?: typeof appsConfig | undefined
}

interface Props {
  links: MenuItem[]
}

interface Context {
  appPath: string
}

const SideNavigation: FC<Props> = ({links}, {appPath}: Context) => {
  return (
    <Nav>
      <Ul>
        {links
          .filter((t) => !!t)
          .map((link: MenuItem) => {
            const {to, label, isCategory, onClick, app, color, id, ...props} = link
            const pathname = window.location.pathname
            return (
              link && (
                <MenuListItem isCategory={!!isCategory} key={label}>
                  <MenuItemLink
                    {...props}
                    id={id}
                    plain
                    isCurrent={pathname === `${appPath}${to}` || pathname.includes(`${appPath}${to}`)}
                    isCategory={isCategory}
                    onClick={onClick}
                    color={color}
                    app={app}
                    to={to}>
                    <FormattedMessage id={label} />
                  </MenuItemLink>
                </MenuListItem>
              )
            )
          })}
      </Ul>
    </Nav>
  )
}

SideNavigation.contextTypes = {
  appPath: PropTypes.string.isRequired
}

export default SideNavigation
